class CustomerStories extends HTMLElement {
  connectedCallback() {
    if (this._isInitialized) {
      return;
    }

    this._viewport = this.querySelector("[data-customer-stories-viewport]");

    if (!this._viewport) {
      return;
    }

    this._isInitialized = true;
    this._isPointerDown = false;
    this._didDrag = false;
    this._pointerId = null;
    this._startX = 0;
    this._startScrollLeft = 0;

    this._onPointerDown = (event) => {
      if (event.pointerType !== "mouse" || event.button !== 0) {
        return;
      }

      this._isPointerDown = true;
      this._didDrag = false;
      this._pointerId = event.pointerId;
      this._startX = event.clientX;
      this._startScrollLeft = this._viewport.scrollLeft;
      this._viewport.classList.add("is-dragging");
      this._viewport.setPointerCapture?.(event.pointerId);
    };

    this._onPointerMove = (event) => {
      if (!this._isPointerDown || event.pointerId !== this._pointerId) {
        return;
      }

      const distance = event.clientX - this._startX;

      if (Math.abs(distance) > 3) {
        this._didDrag = true;
        event.preventDefault();
      }

      this._viewport.scrollLeft = this._startScrollLeft - distance;
    };

    this._onPointerEnd = (event) => {
      if (!this._isPointerDown || event.pointerId !== this._pointerId) {
        return;
      }

      if (this._viewport.hasPointerCapture?.(event.pointerId)) {
        this._viewport.releasePointerCapture(event.pointerId);
      }

      this._isPointerDown = false;
      this._pointerId = null;
      this._viewport.classList.remove("is-dragging");
    };

    this._onClick = (event) => {
      if (!this._didDrag) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      this._didDrag = false;
    };

    this._onDragStart = (event) => event.preventDefault();

    this._viewport.addEventListener("pointerdown", this._onPointerDown);
    this._viewport.addEventListener("pointermove", this._onPointerMove);
    this._viewport.addEventListener("pointerup", this._onPointerEnd);
    this._viewport.addEventListener("pointercancel", this._onPointerEnd);
    this._viewport.addEventListener("click", this._onClick, true);
    this._viewport.addEventListener("dragstart", this._onDragStart);
  }

  disconnectedCallback() {
    this._viewport?.removeEventListener("pointerdown", this._onPointerDown);
    this._viewport?.removeEventListener("pointermove", this._onPointerMove);
    this._viewport?.removeEventListener("pointerup", this._onPointerEnd);
    this._viewport?.removeEventListener("pointercancel", this._onPointerEnd);
    this._viewport?.removeEventListener("click", this._onClick, true);
    this._viewport?.removeEventListener("dragstart", this._onDragStart);
    this._viewport?.classList.remove("is-dragging");
    this._isInitialized = false;
  }
}

if (!window.customElements.get("customer-stories")) {
  window.customElements.define("customer-stories", CustomerStories);
}
